import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

import { ALBUM_KIND, type AlbumMeta, parseAlbum } from '@/lib/album-utils';

/**
 * Query all albums (kind 30006) by a specific author.
 * Returns parsed AlbumMeta array sorted by created_at descending.
 */
export function useUserAlbums(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery<AlbumMeta[]>({
    queryKey: ['albums', 'user', pubkey ?? ''],
    queryFn: async () => {
      if (!pubkey) return [];

      const events = await nostr.query(
        [{ kinds: [ALBUM_KIND], authors: [pubkey], limit: 50 }],
        { signal: AbortSignal.timeout(5000) },
      );

      return events
        .map(parseAlbum)
        .filter((a): a is AlbumMeta => !!a)
        .sort((a, b) => b.createdAt - a.createdAt);
    },
    enabled: !!pubkey,
    staleTime: 60 * 1000,
  });
}
